/** @jsxImportSource @emotion/react */
import { css, keyframes, useTheme } from "@emotion/react";
import { useLanguage } from "../../../LanguageContext";
import FeedbackForm from "./FeedbackForm";
import { useFeedback } from "../../../context/ui/FeedbackModalContext";
import { useOutsideAlerter } from "../../../hooks/useOutsideAlerter";
import React, {useEffect } from "react";

export default function Feedback() {
  const { t } = useLanguage();
  const theme = useTheme();
  const { openFeedback, showFeedbackForm, closeFeedback, reaction, feedbackPlace, feedbackDetail, entityId, entityType, feedbackId } = useFeedback();
  const feedbackFormWraperRef = React.createRef<HTMLDivElement>();
  const [outsideSideMenu] = useOutsideAlerter(feedbackFormWraperRef);

  const hideButton = keyframes`
   0% { transform: rotate(-90deg) translateY(0); }
   100% { transform: rotate(-90deg) translateY(120%); }
  `;

  const showButton = keyframes`
   0% { transform: rotate(-90deg) translateY(120%); }
   100% { transform: rotate(-90deg) translateY(0); }
  `;

  const feedbackWrapperStyles = css`
    position: fixed;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    border-radius: 8px 0 0 8px;
    z-index: 1000;
  `;

  const feedbackBtnStyles = css`
    transform: rotate(-90deg) translateX(50%);
    transform-origin: 68% -32%;
    cursor: pointer;
    background-color: ${theme.colors.feedbackBackground};
    color: ${theme.colors.feedbackTitleColor};
    font-weight: 600;
    padding: 16px 80px;
    text-align: center;
    box-shadow: 0px 4px 30px 0px #00000026;
    border-radius: 8px 8px 0 0;
    transition: transform 0.5s ease-in-out;
    position: fixed;
    right: 0;
    top: 50%;
    z-index: 3;
    transition: transform 0.5s ease-in-out;
    animation: ${showFeedbackForm ? hideButton : showButton} 0.4s ease-in-out forwards;

    
    @media (max-width: 768px) {
      padding: 6px 30px 6px 30px;
      font-size: 14px;
      border-radius: 4px 4px 0 0;
      transform-origin: 60% -50%;
    }
  `;

  const handleOpen = () => {
        openFeedback(null, 'Analysis');
  };

  const handleClose = () => {
          closeFeedback();
  };

 const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
   if (e.key === "Enter") {
      handleOpen();
    }
  };

  useEffect(() => {
    if (showFeedbackForm) {
      handleClose();
    }
  }, [outsideSideMenu]);

  return (
    <div css={feedbackWrapperStyles}>
      {showFeedbackForm && (
        <FeedbackForm
          showFeedbackForm={showFeedbackForm}
          handleClose={handleClose}
          reaction={reaction}
          feedbackPlace={feedbackPlace}
          feedbackDetail={feedbackDetail || null}
          feedbackId={feedbackId}
          entityId={entityId}
          entityType={entityType}
          feedbackFormWraperRef={feedbackFormWraperRef}
          />
      )
      
      } 
      {!showFeedbackForm && <mark role="button" tabIndex={0} css={feedbackBtnStyles} onKeyDown={handleKeyDown} onClick={() => handleOpen()}>{t("feedback_generalTrigger")}</mark>}
    </div>
  );
}
